/**
 * TrustGrid Header Component
 * Top navigation bar with user menu and logout
 */

import React from 'react';
import { Layout, Dropdown, Avatar, Space, Button } from 'antd';
import { UserOutlined, LogoutOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { spacing, colors } from '../../theme/designTokens';

const { Header } = Layout;

function TrustGridHeader({ onLogout }) {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: user?.username || 'User',
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'main-app',
      icon: <AppstoreOutlined />,
      label: 'Main Dashboard',
      onClick: () => navigate('/dashboard'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  return (
    <Header
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        zIndex: 999,
        backgroundColor: '#F8F6F1', // Truvex ivory background
        borderBottom: `1px solid #E8E3DA`, // Truvex border
        padding: `0 ${spacing.lg}px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 64,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}
    >
      {/* Logo/Brand */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src="/truvex-logo-header.png"
          alt="Truvex"
          style={{
            height: 40,
            width: 'auto',
            filter: 'brightness(0) saturate(100%) invert(8%) sepia(48%) saturate(5487%) hue-rotate(267deg) brightness(94%) contrast(104%)',
          }}
        />
      </div>

      {/* User Menu */}
      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Avatar icon={<UserOutlined />} />
          <span>{user?.username || 'User'}</span>
        </Space>
      </Dropdown>
    </Header>
  );
}

export default TrustGridHeader;
